/* Monotone home sections (pm-*): add-to-bag, carousels, showcase selection.
   Uses event delegation so sections keep working after theme-editor re-renders. */
(function () {
  if (window.PMHome) return;
  window.PMHome = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionIds(ui) {
    var ids = [];
    try {
      ui.getSectionsToRender().forEach(function (s) {
        [s.id, s.section].forEach(function (v) { if (v && ids.indexOf(v) === -1) ids.push(v); });
      });
    } catch (e) {}
    return ids.slice(0, 5);
  }

  function addToCart(btn, variantId) {
    if (!variantId || btn.disabled) return;
    var ui = cartUI();
    var label = btn.querySelector('.pm-btn__label');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    btn.classList.add('is-loading');
    var body = { id: Number(variantId), quantity: 1 };
    var ids = ui ? sectionIds(ui) : [];
    if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (label) label.textContent = res.description || res.message || 'Unavailable';
          setTimeout(function () { if (label) label.textContent = original; }, 2500);
          return;
        }
        if (ui && typeof ui.renderContents === 'function' && res.sections) {
          try {
            ui.classList.remove('is-empty');
            ui.renderContents(res);
            return;
          } catch (e) {}
        }
        window.location.href = root + 'cart';
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    /* Add to bag */
    var add = e.target.closest('[data-pm-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-pm-card]');
      var select = card && card.querySelector('select[data-pm-variant]');
      addToCart(add, select ? select.value : add.dataset.variantId);
      return;
    }

    /* Carousel arrows */
    var arrow = e.target.closest('[data-pm-dir]');
    if (arrow) {
      var wrap = arrow.closest('[data-pm-carousel]');
      var track = wrap && wrap.querySelector('[data-pm-track]');
      if (!track) return;
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: step * Number(arrow.dataset.pmDir), behavior: 'smooth' });
      return;
    }

    /* Showcase: pick a product */
    var pick = e.target.closest('[data-pm-pick]');
    if (pick) {
      var show = pick.closest('[data-pm-showcase]');
      if (!show) return;
      var i = pick.dataset.pmPick;
      show.querySelectorAll('[data-pm-pick]').forEach(function (p) {
        p.setAttribute('aria-selected', p.dataset.pmPick === i ? 'true' : 'false');
      });
      show.querySelectorAll('[data-pm-detail]').forEach(function (d) {
        d.hidden = d.dataset.pmDetail !== i;
      });
    }
  });

  /* Variant select updates the price shown on the card's button */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('select[data-pm-variant]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var card = select.closest('[data-pm-card]');
    var btn = card && card.querySelector('[data-pm-add]');
    if (!btn) return;
    var price = btn.querySelector('.pm-btn__price');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    var available = opt.dataset.available === 'true';
    btn.disabled = !available;
    var label = btn.querySelector('.pm-btn__label');
    if (label) label.textContent = available ? btn.dataset.addLabel : btn.dataset.soldLabel;
  });
})();
